const chunkMapping = {
	"3": [
		1375
	],
	"38": [
		6565
	],
	"72": [
		7072
	],
	"166": [
		7573
	],
	"234": [
		947
	],
	"244": [
		681
	],
	"365": [
		4355
	],
	"421": [
		5735
	],
	"464": [
		3637
	],
	"529": [
		2843
	],
	"659": [
		865
	],
	"703": [
		8773
	],
	"741": [
		5895
	],
	"791": [
		6113
	],
	"891": [
		5457
	],
	"990": [
		2117
	],
	"993": [
		6045
	]
};
const idToExternalAndNameMapping = {
	"681": [
		"default",
		"./HeaderApp",
		8891
	],
	"865": [
		"default",
		"./EcommerceApp",
		1457
	],
	"947": [
		"default",
		"./AuthApp",
		8765
	],
	"1375": [
		"default",
		"./BookingBuilderApp",
		37
	],
	"2117": [
		"default",
		"./EmailBuilderApp",
		1103
	],
	"2843": [
		"default",
		"./CustomerAuthenticationApp",
		5217
	],
	"3637": [
		"default",
		"./DynamicFormsAdminApp",
		5521
	],
	"4355": [
		"default",
		"./DynamicFormsApp",
		8233
	],
	"5457": [
		"default",
		"./SidebarApp",
		9661
	],
	"5735": [
		"default",
		"./ServicesApp",
		7353
	],
	"5895": [
		"default",
		"./WebsiteBuilderApp",
		4921
	],
	"6045": [
		"default",
		"./POSApp",
		5225
	],
	"6113": [
		"default",
		"./MarketingApp",
		8449
	],
	"6565": [
		"default",
		"./OffersApp",
		6251
	],
	"7072": [
		"default",
		"./IdleSessionApp",
		1731
	],
	"7573": [
		"default",
		"./POSBackOfficeApp",
		77
	],
	"8773": [
		"default",
		"./ProductManagementApp",
		1257
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}